export const sidebarItemRowClass = (active) =>
  [
    'group flex min-h-11 w-full items-center gap-2.5 rounded-xl px-2.5 text-sm transition-colors',
    active
      ? 'bg-primary-100 font-semibold text-primary-700'
      : 'font-medium text-gray-900 hover:bg-primary-50',
  ].join(' ');

export const sidebarItemIconClass = (active) =>
  `h-5 w-5 flex-shrink-0 ${active ? 'text-primary-700' : 'text-gray-500'}`;

export const sidebarItemLabelClass = (active) =>
  `min-w-0 flex-1 text-left text-sm leading-snug ${active ? 'font-semibold text-primary-700' : 'font-medium text-gray-900'}`;

/** Badge rouge — commandes urgentes (maquette). */
export const NavCountBadgeUrgent = ({ count }) => {
  if (!count || count <= 0) return null;
  return (
    <span className="mr-1 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1.5 text-[11px] font-bold text-white">
      {count > 99 ? '99+' : count}
    </span>
  );
};

/** Badge violet clair — compteurs secondaires. */
export const NavCountBadgeSoft = ({ count }) => {
  if (!count || count <= 0) return null;
  return (
    <span className="mr-1 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-primary-100 px-1.5 text-[11px] font-bold text-primary-700">
      {count > 99 ? '99+' : count}
    </span>
  );
};

const SidebarItem = ({
  icon: Icon,
  label,
  active = false,
  onClick,
  href,
  badge = null,
  title,
  as = 'button',
}) => {
  const className = sidebarItemRowClass(active);
  const inner = (
    <>
      <Icon className={sidebarItemIconClass(active)} aria-hidden />
      <span className={sidebarItemLabelClass(active)}>{label}</span>
      {badge}
    </>
  );

  if (as === 'a') {
    return (
      <a href={href} onClick={onClick} className={className} title={title}>
        {inner}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={className} title={title}>
      {inner}
    </button>
  );
};

export default SidebarItem;
